export default __webpack_public_path__ + "static/media/man.59d0bc26.png";